<ng-container *ngIf="card">
  <app-mobile-offer-details [cardData]="card" />
  <div class="rate__button--mobile-wrapper">
    <button
      class="rate__button rate__button--mobile"
      (click)="
        onClosingTrack(
          card.closingTrackToken,
          card.offerResponse?.terms?.loanAmount
        )
      "
      *ngIf="
        card.contractState === 'NEW' ||
        card.contractState === 'PRELIMINARY_OFFER' ||
        card.contractState === 'PRELIMINARY_ACCEPTED' ||
        card.contractState === 'ACCEPTED' ||
        card.contractState === 'IDENT_STARTED' ||
        card.contractState === 'IDENT_FINISHED' ||
        card.contractState === 'DOCUMENTS_MISSING' ||
        card.contractState === 'DOCUMENTS_MISSING_2ND' ||
        (card.contractState === 'CLOSING_FINISHED' &&
          card.bankProduct.bankDetails.bankGateway === 'NOVUMBANK')
      "
    >
      <span
        *ngIf="
          (sharedResultService.eternalPage &&
            card.contractStateFlow !== 'PRELIMINARY' &&
            (card.contractState === 'NEW' ||
              card.contractState === 'ACCEPTED')) ||
          ((card.contractStateFlow === 'PRELIMINARY' ||
            card.contractStateFlow === 'CLICKOUT') &&
            card.contractState === 'PRELIMINARY_ACCEPTED' &&
            card.bankProduct.bankDetails.bankGateway !== 'OBERBANK')
        "
        >zum Kreditabschluss</span
      >
      <span
        *ngIf="
          card.contractStateFlow === 'PRELIMINARY' &&
          card.contractState === 'PRELIMINARY_ACCEPTED' &&
          card.bankProduct.bankDetails.bankGateway == 'OBERBANK'
        "
        >zur Terminvereinbarung</span
      >
      <span *ngIf="card.contractState === 'IDENT_STARTED'"
        >zur Videotelefonie</span
      >
      <span
        *ngIf="
          (card.contractStateFlow === 'PRELIMINARY' &&
            card.contractState === 'PRELIMINARY_OFFER') ||
          (card.contractStateFlow !== 'PRELIMINARY' &&
            card.contractState === 'IDENT_FINISHED')
        "
        >zum Dokumentenupload</span
      >
      <span
        *ngIf="
          card.contractState === 'DOCUMENTS_MISSING' ||
          card.contractState === 'DOCUMENTS_MISSING_2ND'
        "
        >Unterlagen nachreichen</span
      >
      <span
        *ngIf="
          (sharedResultService.resultPage &&
            ((card.contractStateFlow !== 'PRELIMINARY' &&
              (card.contractState === 'NEW' ||
                card.contractState === 'ACCEPTED')) ||
              (card.contractStateFlow === 'CLICKOUT' &&
                card.contractState === 'PRELIMINARY_OFFER') ||
              (card.contractStateFlow === 'DEFAULT' &&
                card.contractState === 'PRELIMINARY_ACCEPTED'))) ||
          (card.contractState === 'CLOSING_FINISHED' &&
            card.bankProduct.bankDetails.bankGateway === 'NOVUMBANK')
        "
        >weiter</span
      >
    </button>
    <p
      class="rate__text-mobile"
      *ngIf="
        card.contractState === 'REJECTED' ||
        card.contractState === 'DOCUMENTS_UPLOADED' ||
        card.contractState === 'DOCUMENTS_UPLOADED_2ND' ||
        card.contractState === 'DOCUMENTS_CHECKED' ||
        card.contractState === 'DOCUMENTS_CHECKED_2ND' ||
        card.contractState === 'REJECTED_2ND' ||
        card.contractState === 'REJECTED_CLEARING' ||
        (card.contractState === 'CLOSING_FINISHED' &&
          card.bankProduct.bankDetails.bankGateway !== 'NOVUMBANK') ||
        card.contractState === 'CLOSED'
      "
    >
      <b
        class="icon-warning"
        *ngIf="
          card.contractState === 'REJECTED' ||
          card.contractState === 'REJECTED_2ND' ||
          card.contractState === 'REJECTED_CLEARING'
        "
        >!</b
      >
      <svg
        *ngIf="
          card.contractState === 'DOCUMENTS_UPLOADED' ||
          (card.contractState === 'CLOSING_FINISHED' &&
            card.bankProduct.bankDetails.bankGateway !== 'NOVUMBANK') ||
          (card.contractStateFlow === 'PRELIMINARY' &&
            card.contractState === 'IDENT_FINISHED')
        "
        class="icon-clock"
        version="1.2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        overflow="visible"
        preserveAspectRatio="none"
        viewBox="0 0 34 34"
        height="32"
        width="32"
      >
        <g transform="translate(1, 1)">
          <title>clock</title>
          <path
            d="M16.352 14.464v-6.048h-1.28v6.144c-0.32 0.256-0.672 0.736-0.672 1.28 0 0.832 0.704 1.472 1.536 1.472 0.608 0 1.12-0.256 1.376-0.896h5.44v-1.28h-5.504c-0.16-0.32-0.576-0.544-0.896-0.672z"
            fill="#444"
            vector-effect="non-scaling-stroke"
          />
          <path
            d="M31.744 19.36c0.224-1.088 0.32-2.272 0.32-3.456 0-0.512-0.032-1.024-0.064-1.536-0.832-8.064-7.648-14.368-15.968-14.368-8.864 0-16.032 7.168-16.032 16.032 0 7.424 5.024 13.664 11.872 15.488 1.312 0.32 2.656 0.48 4.096 0.48 1.984 0 3.84-0.32 5.536-0.864 5.152-1.888 9.088-6.304 10.24-11.776zM16.352 28.896v-3.2h-1.28v3.168c-6.72-0.416-11.744-5.728-12.032-12.448h2.752v-1.28h-2.72c0.448-6.4 5.6-11.68 12-12.096v2.816h1.28v-2.816c6.72 0.288 12.096 5.376 12.544 12.096h-3.264v1.28h3.264c-0.288 6.72-5.504 12.16-12.544 12.48z"
            fill="#444"
            vector-effect="non-scaling-stroke"
          />
        </g>
      </svg>
      <b
        class="icon-ok"
        *ngIf="
          card.contractState === 'DOCUMENTS_CHECKED' ||
          card.contractState === 'CLOSED'
        "
      ></b>
      <span
        *ngIf="
          card.contractState === 'REJECTED' ||
          card.contractState === 'REJECTED_2ND' ||
          card.contractState === 'REJECTED_CLEARING'
        "
        >abgelehnt</span
      >
      <span
        *ngIf="
          card.contractStateFlow === 'PRELIMINARY' &&
          card.contractState === 'IDENT_FINISHED'
        "
        >Vertrag wird an Bank übermittelt</span
      >
      <span
        *ngIf="
          card.contractState === 'DOCUMENTS_UPLOADED' ||
          card.contractState === 'DOCUMENTS_UPLOADED_2ND'
        "
        >Dokumente werden geprüft</span
      >
      <span
        *ngIf="
          card.contractState === 'DOCUMENTS_CHECKED' ||
          card.contractState === 'DOCUMENTS_CHECKED_2ND'
        "
        >Dokumente werden geprüft</span
      >
      <span
        *ngIf="
          card.contractState === 'CLOSING_FINISHED' &&
          card.bankProduct.bankDetails.bankGateway !== 'NOVUMBANK'
        "
        >Kreditauszahlung wird geprüft</span
      >
      <span *ngIf="card.contractState === 'CLOSED'"
        >Kredit wird ausbezahlt</span
      >
    </p>
  </div>
</ng-container>
